export class TagBoxBounds {
    static clamp({ left, top }, { width, height }, container, edgeMargin = 0) {
        return {
            left: Math.max(0, Math.min(left, container.width  - width  - edgeMargin)),
            top:  Math.max(0, Math.min(top,  container.height - height - edgeMargin)),
        };
    }
}
